import { useRef } from 'react';

import { TextField, InputAdornment, Icon, IconButton } from '@material-ui/core';

import { useSnackbar } from 'notistack';
import PropTypes from 'prop-types';

function InputCopyPaste(props) {
  const { value, label, ...otherProps } = props;

  const lineCodeRef = useRef(null);
  const { enqueueSnackbar } = useSnackbar();

  let supportCopy = null;

  if (document && document.queryCommandSupported)
    supportCopy = document.queryCommandSupported('copy');

  function copyToClipboard() {
    lineCodeRef.current.select();
    document.execCommand('copy');
    enqueueSnackbar('Código copiado com sucesso!', { variant: 'success' });
  }

  return (
    <TextField
      multiline
      label={label}
      value={value}
      inputProps={{ ref: lineCodeRef }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      InputProps={{
        endAdornment: supportCopy && (
          <InputAdornment position="end">
            <IconButton onClick={() => copyToClipboard()}>
              <Icon fontSize="inherit">file_copy_outlined</Icon>
            </IconButton>
          </InputAdornment>
        ),
      }}
      onClick={() => copyToClipboard()}
      {...otherProps}></TextField>
  );
}

InputCopyPaste.propTypes = {
  value: PropTypes.any,
  label: PropTypes.any,
};

export default InputCopyPaste;
